import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Approach from "@/components/Approach";
import About from "@/components/About";
import Marquee from "@/components/Marquee";
import Cabinet from "@/components/Cabinet";
import Conseils from "@/components/Conseils";
import Instagram from "@/components/Instagram";
import Avis from "@/components/Avis";
import Faq from "@/components/Faq";
import Motifs from "@/components/Motifs";
import Tarifs from "@/components/Tarifs";
// import Ebooks from "@/components/Ebooks"; // section désactivée temporairement (refonte des ebooks en cours)
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MentionsLegales from "@/pages/MentionsLegales";

const HomePage = () => (
  <div className="bg-ivory font-sans text-anthracite">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Approach />
      <About />
      <Cabinet />
      <Motifs />
      <Tarifs />
      <Conseils />
      <Instagram />
      <Avis />
      <Faq />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
